<div class="btn-group btn-group-lg pills d-flex">
	<ng-container *ngFor="let option of options; let i = index">
		<input
			[formControl]="control"
			type="radio"
			class="btn-check rounded-pill"
			[name]="'btnradio' + pseudoRandomId"
			attr.id="{{ i === 0 ? 'left' : 'right' }}Choice{{ pseudoRandomId }}"
			autocomplete="off"
			[value]="options[i].value"
		/>
		<label
			[ngClass]="{ 'pill-left': i === 0, 'pill-right': i === 1 }"
			[class.disabled]="isDisabled"
			class="btn btn-outline-primary shadow-none pill w-100 truncate-text"
			attr.for="{{ i === 0 ? 'left' : 'right' }}Choice{{
				pseudoRandomId
			}}"
			>{{ options[i].label }}</label
		>
	</ng-container>
</div>
